export default "__VITE_ASSET__Dk8XcDRJ__"